export default {
  DIETITIANS(state, payload) {
    payload.data = payload.data.map(d => d.employee)
    state.dietitians = payload || {}
  },
  SET_DIETITIAN(state, payload) {
    state.currentDietitian = payload
  }
}



// WEBPACK FOOTER //
// ./src/app/store/dietitians/mutations.js